function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12C5.372 0 0 5.372 0 12c0 6.627 5.372 12 12 12z",
  fill: "#F0F0F0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8.87h11.586a11.888 11.888 0 00-1.346-3.13H12.012v3.13H12zM4.535 21.39h14.929a11.871 11.871 0 002.763-3.13H1.771a12.28 12.28 0 002.764 3.13zM11.998.012v2.61h7.465a11.87 11.87 0 00-7.465-2.61z",
  fill: "#338AF3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8.87h11.586a11.888 11.888 0 00-1.346-3.13H12.012v3.13H12zM.012 12c0 1.087.142 2.126.414 3.13h23.16c.272-.992.414-2.043.414-3.13H.012z",
  fill: "#338AF3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.441 7.028l-1.464.685.78 1.417-1.595-.295-.201 1.606-1.11-1.193-1.099 1.193-.2-1.606-1.595.295.78-1.417-1.465-.685 1.465-.697-.78-1.418 1.583.308.212-1.607 1.099 1.181 1.11-1.18.2 1.606 1.595-.308-.78 1.418 1.465.697z",
  fill: "#FFDA44"
});

function SvgFlagUy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "/img/flag_uy.svg";
export { SvgFlagUy as ReactComponent };